<template>
  <v-card class="fill-height" width="100vw">
    <v-card-text>
    <DataTable
      :headers="headers"
      :items="corporations.items"
      :options="options_raw"
      :total="corporations.total"
      searchable
      @updateOptions="updateOptions"
      @onSearch="searchQuery"
      @onAdd="$emit('onAdd')"
      @onClickRow="onClickRow"
    >
      <template #add>
        <Dialog color="primary" btn_icon="mdi-plus" 
          btn_text="Добавить" title="Создание организации" btn_classes="mr-2" 
          @onSubmit="onAdd"
        >
          <template #body>
            <v-row>
              <v-col cols="12">
                <TextField label="Название корпорации" filled v-model="corporation.name"/>
              </v-col>
              <v-col cols="12">
                <SelectField
                  item-text="name"
                  filled
                  v-model="dealer"
                  :item-value="(value) => value"
                  @change="
                    (v) => {
                      corporation.creator_id = v.id;
                      corporation.creator_name = v.name;
                    }
                  "
                  :items="dealers"
                />
              </v-col>
            </v-row>
          </template>
        </Dialog>
      </template>
    </DataTable>
  </v-card-text>
</v-card>
</template>

<script>
import DataTable from '../ui/DataTable.vue';
import Dialog from '@/components/ui/Dialog';
import TextField from '@/components/ui/TextField.vue';
import SelectField from '../ui/SelectField.vue';

export default{
  name: 'corporations-list',

  props:{
    dealers: Array,
    corporations: Object
  },

  data: () => ({
    corporation: {
      name: null,
      creator_name: null,
      creator_id: null
    },
    dealer: {},
    options: {}
  }),

  computed: {
    headers(){
      return [
        {text: '#', align: 'start', value: 'id'}, 
        {text: 'Название', align: 'start', value: 'name'},
        {text: 'Дилер', align: 'start', value: 'creator_name'},
        {text: 'Количество объектов', align: 'start', sortable: false, value: 'shops.length'}, 
        {text: 'Активен', align: 'start', value: 'enabled'}, 
        {text: 'Дата создания', align: 'start', value: 'created_at'},
      ]
    },

    options_raw:{
      set(v){
        this.options = {...this.options,...v}
      },
      get(){
        return this.options
        // if (!this.corporations || Object.keys(this.corporations).length == 0) return {};
      
        // return {
        //   sortBy: this.corporations.order_by ? this.corporations.order_by : [],
        //   sortDesc: this.corporations.direction ? this.corporations.direction : [],
        //   itemsPerPage: this.corporations.limit ? this.corporations.limit : 50,
        //   page: this.corporations.skip ? this.corporations.skip : 1,
        //   include_deleted: this.corporations.include_deleted ? this.corporations.include_deleted : false
        // }
      }
    
    }
  },

  methods: {
    updateOptions(options){
      this.$emit('onGetList', {
        skip: options.page,
        limit: options.itemsPerPage,
        order_by: options.sortBy[0] ? options.sortBy[0] : null,
        direction: options.sortDesc[0] ? options.sortDesc[0] : null,
        include_deleted: options.include_deleted,
        query: options.query
      })
    },

    searchQuery(query){
      this.$emit('onSearch', {query: query, options: this.options});
    },

    onClickRow(item){
      this.$emit('onClickRow', item);
    },

    onAdd(){
      this.$emit('onAdd', this.corporation);
      this.corporation = { name: null, creator_name: null, creator_id: null };
      this.dealer={};
    }
  },

  mounted(){
    this.options = {
      sortBy: this.corporations.order_by ? this.corporations.order_by : [],
      sortDesc: this.corporations.direction ? this.corporations.direction : [],
      itemsPerPage: this.corporations.limit ? this.corporations.limit : 10,
      page: this.corporations.skip ? this.corporations.skip : 1,
      include_deleted: this.corporations.include_deleted ? this.corporations.include_deleted : false,
      query: null
    }
  },

  components:{
    Dialog,
    TextField,
    SelectField,
    DataTable
  }
}
</script>